import { render, staticRenderFns } from "./BudgetRequestsView.vue?vue&type=template&id=4f9e18e4&lang=pug"
import script from "./BudgetRequestsView.vue?vue&type=script&lang=js"
export * from "./BudgetRequestsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports